import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

import {
    FormatDate
} from '../../../../../libraries/Tool';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="if">
                    1.&nbsp;<span className="material-symbols-outlined">call_split</span>&nbsp;{translate('if')}
                </Typography>
                <p><strong>{translate('if')}</strong> 指定された条件に応じて処理を分岐させるアクションです。条件が true の場合、ブロックで定義されたアクションを実行します。</p>
                <ul style={{ listStyle: "none" }}>
                    <p>
                        <strong>a.&nbsp;{translate('parameters__title')}</strong>
                    </p>
                    <li>
                        <table className='parameters'>
                            <ParametersTableHeader />
                            <tbody>
                                <tr>
                                    <td>{translate('condition')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="text" />
                                    </td>
                                    <td>判定条件</td>
                                    <td></td>
                                </tr>
                                
                            </tbody>
                        </table>
                    </li>
                    <p>
                        <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                    </p>
                    <li>
                        <ReturnTypeValue />
                    </li>
                    <p>
                        <strong>c.&nbsp;{translate('example__title')}</strong>
                    </p>
                    <li>
                        <div className='results'>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('condition')}</span>
                                <div><span className='parameter-fx'>fx(<span className='parameter-fx-value'>GetCurrentDate(7 , "YYYY-MM-DD")</span>)</span>&nbsp;=&nbsp;"{FormatDate(new Date(), "yyyy-MM-dd")}"</div>
                            </div>
                        </div>
                    </li>
                </ul>
                <Typography variant="h5" gutterBottom id="loop">
                    2.&nbsp;<span className="material-symbols-outlined">cached</span>&nbsp;{translate('loop')}
                </Typography>
                <p><strong>{translate('loop')}</strong> プロセスを指定された回数だけ繰り返すアクションです。</p>
                <ul style={{ listStyle: "none" }}>
                    <p>
                        <strong>a.&nbsp;{translate('parameters__title')}</strong>
                    </p>
                    <li>
                        <table className='parameters'>
                            <ParametersTableHeader />
                            <tbody>
                                <tr>
                                    <td>{translate('outputkey')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="text" />
                                    </td>
                                    <td>現在の反復回数です (0 から始まります)。</td>
                                    <td>$i_1</td>
                                </tr>
                                <tr>
                                    <td>{translate('times')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="number" />
                                    </td>
                                    <td>繰り返しの回数です。</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                    <p>
                        <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                    </p>
                    <li>
                        <ReturnTypeValue type="number" />
                    </li>
                    <p>
                        <strong>c.&nbsp;{translate('example__title')}</strong>
                    </p>
                    <li>
                        <div className='results'>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('outputkey')}</span>
                                <div>$i_1</div>
                            </div>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('condition')}</span>
                                <div>3</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>0</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>1</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>2</div>
                            </div>
                        </div>
                    </li>
                </ul>
                <Typography variant="h5" gutterBottom id="forearch">
                    3.&nbsp;<span className="material-symbols-outlined">repeat</span>&nbsp;{translate('forearch')}
                </Typography>
                <p><strong>{translate('forearch')}</strong> 配列の各要素に対してプロセスを繰り返すアクションです。</p>
                <ul style={{ listStyle: "none" }}>
                    <p>
                        <strong>a.&nbsp;{translate('parameters__title')}</strong>
                    </p>
                    <li>
                        <table className='parameters'>
                            <ParametersTableHeader />
                            <tbody>
                                <tr>
                                    <td>{translate('outputkey')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="text" />
                                    </td>
                                    <td>配列内の各要素の値</td>
                                    <td>$item_1</td>
                                </tr>
                                <tr>
                                    <td>{translate('iterable')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="array" />
                                    </td>
                                    <td>走査される配列</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                    <p>
                        <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                    </p>
                    <li>
                        <ReturnTypeValue type="any" />
                    </li>
                    <p>
                        <strong>c.&nbsp;{translate('example__title')}</strong>
                    </p>
                    <li>
                        <div className='results'>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('outputkey')}</span>
                                <div>$item_1</div>
                            </div>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('iterable')}</span>
                                <div>{`["red", "green", "blue"]`}</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>red</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>green</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>blue</div>
                            </div>
                        </div>
                    </li>
                </ul>
                <Typography variant="h5" gutterBottom id="breakif">
                    4.&nbsp;<span className="material-symbols-outlined">do_not_disturb_alt</span>&nbsp;{translate('breakif')}
                </Typography>
                <p><strong>{translate('breakif')}</strong> これは、Loop/ForEarch を終了し、Loop/ForEach ブロック内に配置するアクションです。指定された条件が true の場合、ループ ブロック (Loop/ForEach) を終了し、ブロックの外の次のタスクに進みます。反復がネストされている場合は、最も内側のループを終了します。</p>
                <ul style={{ listStyle: "none" }}>
                    <p>
                        <strong>a.&nbsp;{translate('parameters__title')}</strong>
                    </p>
                    <li>
                        <table className='parameters'>
                            <ParametersTableHeader />
                            <tbody>
                                <tr>
                                    <td>{translate('condition')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="text" />
                                    </td>
                                    <td>判定条件</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                    <p>
                        <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                    </p>
                    <li>
                        <ReturnTypeValue />
                    </li>
                    <p>
                        <strong>c.&nbsp;{translate('example__title')}</strong>
                    </p>
                    <li>
                        <div className='results'>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('condition')}</span>
                                <div><span className='parameter-fx'>fx(<span className='parameter-fx-value'>GetCurrentDate(7 , "YYYY-MM-DD")</span>)</span>&nbsp;=&nbsp;"{FormatDate(new Date(), "yyyy-MM-dd")}"</div>
                            </div>
                        </div>
                    </li>
                </ul>
                <Typography variant="h5" gutterBottom id="wait">
                    5.&nbsp;<span className="material-symbols-outlined">hourglass_top</span>&nbsp;{translate('wait')}
                </Typography>
                <p><strong>{translate('wait')}</strong> 次のアクションに進むのを待つアクションです。</p>
                <ul style={{ listStyle: "none" }}>
                    <p>
                        <strong>a.&nbsp;{translate('parameters__title')}</strong>
                    </p>
                    <li>
                        <table className='parameters'>
                            <ParametersTableHeader />
                            <tbody>
                                <tr>
                                    <td>{translate('timeout')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="number" />
                                    </td>
                                    <td>待機時間 (ミリ秒単位)</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                    <p>
                        <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                    </p>
                    <li>
                        <ReturnTypeValue />
                    </li>
                    <p>
                        <strong>c.&nbsp;{translate('example__title')}</strong>
                    </p>
                    <li>
                        <div className='results'>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('condition')}</span>
                                <div><span className='parameter-fx'>fx(<span className='parameter-fx-value'>GetCurrentDate(7 , "YYYY-MM-DD")</span>)</span>&nbsp;=&nbsp;"{FormatDate(new Date(), "yyyy-MM-dd")}"</div>
                            </div>
                        </div>
                    </li>
                </ul>
                <Typography variant="h5" gutterBottom id="runjavascript">
                    6.&nbsp;<span className="material-symbols-outlined">javascript</span>&nbsp;{translate('runjavascript')}
                </Typography>
                <p><strong>{translate('runjavascript')}</strong> アクション内で JavaScript を実行するアクションです。</p>
                <ul style={{ listStyle: "none" }}>
                    <p>
                        <strong>a.&nbsp;{translate('parameters__title')}</strong>
                    </p>
                    <li>
                        <table className='parameters'>
                            <ParametersTableHeader />
                            <tbody>
                                <tr>
                                    <td>{translate('outputkey')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="text" />
                                    </td>
                                    <td>JavaScript コードを実行した後の戻り値 (存在する場合)</td>
                                    <td>$runJavascript_1</td>
                                </tr>
                                <tr>
                                    <td>{translate('code')}<span>*</span></td>
                                    <td>
                                        <ParametersTypeValue type="text" />
                                    </td>
                                    <td>実行する JavaScript コード</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                    <p>
                        <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                    </p>
                    <li>
                        <ReturnTypeValue type="any" />
                    </li>
                    <p>
                        <strong>c.&nbsp;{translate('example__title')}</strong>
                    </p>
                    <li>
                        <div className='results'>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('outputkey')}</span>
                                <div>$runJavascript_1</div>
                            </div>
                            <div className='parameter'>
                                <span className='parameter-name'>{translate('code')}</span>
                                <div>let a = 1; let b = 2; return a + b;</div>
                            </div>
                            <div className='output'>
                                <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <div>3</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </Box>
    );
}
export default withTranslate(En);